import React from 'react';
import ReactOnRails from 'react-on-rails';
import ComparisonDisplay from './comparison_display.js';
import CheckAnswer from './check_answer.js';
import Feedback from './feedback.js';
import ComparisonButtons from './comparison_buttons.js';
import NewProblemButton from './new_problem_button.js';
import {createComparisonNumber} from './lib/inequality';
import SelectRange from './select_range.js';
import Stats from '../shared_components/stats.js';

export default class Inequality extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedChoice: 'option1',
			comparisonNumbers: createComparisonNumber(0, 100),
			equalitySymbol: '?',
			isAnswerCorrect: '',
			isAnswerSubmitted: false,
			totalAttempted: 0,
			totalCorrect: 0,
			symbolButtonsPressed: false
		};

		this.getNewProblem = this.getNewProblem.bind(this);
		this.updateEqualitySymbol = this.updateEqualitySymbol.bind(this);
		this.updateAnswerAndStats = this.updateAnswerAndStats.bind(this);
		this.updateSelectChoice = this.updateSelectChoice.bind(this);
		this.getNewProblemHandler = this.getNewProblemHandler.bind(this);
	}

	getNewProblem(selectedRange){
		selectedRange = selectedRange || this.state.selectedChoice;
		var comparisonNumbers = this.numberRange(selectedRange);

		this.setState({
			equalitySymbol: '?',
			isAnswerSubmitted: false,
			symbolButtonsPressed: false,
			comparisonNumbers: comparisonNumbers,
			selectedChoice: selectedRange
		});
	}

	getNewProblemHandler() {
		this.getNewProblem();
	}

	updateEqualitySymbol(symbol) {
		this.setState({
			equalitySymbol: symbol,
			isAnswerSubmitted: false,
			symbolButtonsPressed: true
		});
	}

	// need originates onClick in CheckAnswer; 
	// passes true or false to checkComparisonAnswer on same click;
	// checkComparisonAnswer is called as value of the prop answerStatus on CheckAnswer
	updateAnswerAndStats(checkComparisonAnswer){
		var totalCorrect = this.state.totalCorrect;

		this.setState({
			isAnswerCorrect: checkComparisonAnswer,
			isAnswerSubmitted: true
		});	

		if(this.state.symbolButtonsPressed) {
			if(checkComparisonAnswer) {
				totalCorrect++;
			} 
			this.setState({
				totalAttempted: this.state.totalAttempted += 1,
				totalCorrect: totalCorrect
			});	
		}
	}

	updateSelectChoice(selected) {
		this.getNewProblem(selected);
	}

	numberRange(option){
		if(option === 'option1'){
			return createComparisonNumber(0, 100);
		}
		if(option === 'option2'){
			return createComparisonNumber(100, 1000);
		}
		if(option === 'option3'){
			return createComparisonNumber(1000, 10000);
		}
	}

	render() {
		return (
			<div>
				<Stats 
					totalAttempted={this.state.totalAttempted} 
					totalCorrect={this.state.totalCorrect}
					totalAttemptedClass = "inequality-stats__attempted"
					totalCorrectClass = "inequality-stats__correct" />
				<ComparisonDisplay 
					leftNumber={this.state.comparisonNumbers.leftNumber}
					equalitySymbol={this.state.equalitySymbol} 
					rightNumber={this.state.comparisonNumbers.rightNumber} />
				<ComparisonButtons updateEqualitySymbol={this.updateEqualitySymbol} />
				<Feedback 
					isAnswerCorrect={this.state.isAnswerCorrect} 
					visible={this.state.isAnswerSubmitted}
					leftNumber={this.state.comparisonNumbers.leftNumber}
					equalitySymbol={this.state.equalitySymbol} 
					rightNumber={this.state.comparisonNumbers.rightNumber}
					showInitialFeedback={!this.state.symbolButtonsPressed} />
				<CheckAnswer 
					leftNumber={this.state.comparisonNumbers.leftNumber} 
					rightNumber={this.state.comparisonNumbers.rightNumber}
					equalitySymbol={this.state.equalitySymbol}
					answerStatus={this.updateAnswerAndStats}
					isAnswerSubmitted={this.state.isAnswerSubmitted} />
				<NewProblemButton getNewProblemHandler={this.getNewProblemHandler} />
				<hr className="inequality-hr" />
				<SelectRange updateSelectChoice={this.updateSelectChoice} />
			</div>
			);
		}
	}

	ReactOnRails.register({ Inequality });



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/inequality/component.js
 **/